export const cilWindow = ["24 24","<path d='M19.875 20.625v-18.375h-15.75v18.375h-1.875v1.5h19.5v-1.5zM5.625 3.75h5.625v5.625h-5.625zM5.625 10.875h5.625v6.75h-5.625zM18.375 20.625h-12.75v-1.5h12.75zM18.375 17.625h-5.625v-6.75h5.625zM18.375 9.375h-5.625v-5.625h5.625z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-window.js
// module id = null
// module chunks = 